module.exports = __webpack_public_path__ + "img/170624.6b50c60b.png";